<template>
    <div v-if ="!roleLoading">
        <div v-if="!permissionLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Role Dispaly</h4>
                    <p class="text-subtitle-1">Role info</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn
                        block
                        depressed
                        @click="handleEdit"
                        v-if="hasPermission(permissions.user.update)"
                        >
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn 
                        block
                        depressed
                        class="red--text"
                        @click="handleDelete"
                        :loading="deleteLoading"
                        v-if="hasPermission(permissions.user.delete)"
                        >
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-subheader>Basic Information</v-subheader>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <td>{{data.name}}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-subheader>Permissions

                    </v-subheader>
                    <v-text-field
                        outlined
                        dense
                        hide-details="auto"
                        label="Search"
                        v-model="permissionSearch"
                    >
                        
                    </v-text-field>
                <v-treeview
                        dense
                        v-model="data.permissions"
                        :items="permissionsList"
                        selectable
                        selected-color="primary"
                        item-disabled="id"
                        :search="permissionSearch"
                        open-all
                        >
                    </v-treeview>
                </v-col>
                <v-col>
                    <v-subheader>Users
                        <v-spacer></v-spacer>
                        <v-btn 
                            text
                            @click="handleAddUser"
                        >add user
                        </v-btn>
                    </v-subheader>
                    <v-text-field
                        outlined
                        dense
                        hide-details="auto"
                        label="Search"
                        v-model="userSearch"
                    >
                        
                    </v-text-field>
                    <v-data-table
                        :items="roleUsers"
                        :headers="headers"
                        :search="userSearch"
                        :loading="userLoading"
                        dense
                    >
                        <template v-slot:[`item.name`]="{ item }">
                            <v-btn icon @click="navgateToUesr(item)">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                                {{item.name}}
                        </template>
                        <template v-slot:[`item.inactive`]="{ item }">
                            <v-icon :color="item.inactive ? 'error' : 'success'">
                                {{ item.inactive ? 'mdi-account-cancel' : 'mdi-account-check'  }}
                            </v-icon>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <v-btn icon 
                                :loading="deleteLoading"
                                @click="handleRemoveUserRole(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <v-dialog
            v-model="userDialog"
            persistent
            width="500"
        >
            <RoleAddUserDialog
                :role="id"
                @cancel="handleCancel"
                @success="handleSuccess"
           />
        </v-dialog>
    </div>
</template>

<script>
import RoleAddUserDialog from '../../components/administration/RoleAddUserDialog'
import permissions from "../../data/permissions" ;
import { mapActions } from 'vuex'
import PAlert from "./../../components/common/PAlert.vue"
import permission from "./../../services/administration/permission"
import role from "./../../services/administration/role"
import authorize from '../../utils/authorize';
import roleUser from './../../services/administration/roleUser'
export default {
    components: {
        PAlert,
        RoleAddUserDialog
    },
    data() {
        return {
            id: null,
            data: {},
            permissionsList : [],
            roleLoading: false,
            permissionLoading: false,
            disabled: true,
            alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            },
            deleteLoading: false,
            roleUsers: [],
            headers: [
                {text: "Name", value: 'name'},
                {text: "Active", value: 'inactive'},
                { text: "Action", value: "action" }
            ],
            userLoading: false,
            permissions,
            permissionSearch: "",
            userSearch: "",
            userDialog: false,
            user_role: {}
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        fetchRole(id) {
            this.roleLoading = true
            role.get(id).then(response => {
                this.data = {...response.data}
            }).finally(() => {
                this.roleLoading = false
            })
        },
        fetchPermissions() {
            this.permissionLoading = true
            permission.tree().then(response => {
                this.permissionsList = [
                    ...response.data 
                ]
            }).finally(() => {
                this.permissionLoading = false
            })
        },
        handleEdit() {
            this.$router.push({name: "RoleEdit", params: {id : this.id}})
        },
        handleDelete() {
            this.alert = { 
                ...this.alert , 
                value : true,
                content: "Are you sure you want to delete?",
                callback: this.remove
            }
        },
        remove() {
            role.remove(this.id).then(response => {
                this.snackbar({
                    text: response.data.message,
                    color: "success"
                })
                this.$router.push({ name: "Roles" })
            }).finally(() => {
                this.deleteLoading = false
            })
        },
        fetchUsers(id) {
            this.roleUsers = [];
            this.userLoading = true
            role.users(id).then(response => {
                this.roleUsers = [
                    ...this.roleUsers,
                    ...response.data
                ]
            }).finally(() => {
                this.userLoading = false
            })
        },
        navgateToUesr(item) {
            this.$router.push({name: "UserDisplay", params: {id: item.user_id}})
        },
        hasPermission(permission) {
            return authorize(permission)
        },
        handleAddUser() {
            this.userDialog = true
        },
        handleCancel() {
            this.userDialog = false
        },
        handleSuccess(message) {
            this.roleUsers=[];
            this.fetchUsers(this.id)
            this.userDialog = false
            this.snackbar({
                text: message,
                color: "success"
            })
        },
        handleRemoveUserRole(item){
            this.user_role = item
            this.alert = { 
                ...this.alert , 
                value : true,
                content: `Are you sure you want to remove ${this.data?.name} Role from ${item.name}?`,
                callback: this.removeUserRole
            }

        },
        removeUserRole() {
            let {user_id, role_id} = this.user_role
            this.userLoading = true;
            roleUser.remove(user_id, role_id).then(response => {
                this.snackbar({
                    text: response.data.message,
                    color: "success"
                })
                this.fetchUsers(this.id)
            }).finally(() => {
                this.userLoading = false
            })
        }
    },
    created() {
        this.id = Number(this.$route.params.id)
        this.fetchPermissions()
        this.fetchRole(this.id)
        this.fetchUsers(this.id)
    }
}
</script>

<style>

</style>